import { useMutation, useQueryClient } from '@tanstack/react-query'

import { REQUESTS_LIST_RQ_KEY } from '@/api/models/requests/hooks/useRequestsList'
import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { ParkingService } from '../lib/parking.service'
import { CreateBookingFormData } from '../lib/parking.types'

type Props = CreateBookingFormData

export const useCreateBooking = ({
  premiseId,
  from,
  to,
  autoNumber,
  autoModel,
  type,
  isStandard,
  personalAccountId
}: Props) => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () =>
      ParkingService.createBooking({
        projectId,
        premiseId,
        from,
        to,
        autoNumber,
        autoModel,
        type,
        isStandard,
        personalAccountId
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [REQUESTS_LIST_RQ_KEY]
      })
    }
  })
}
